import base from './base2.repository';

export default {
    ...base,
    loadSatisfactionPolls(filters, page){
        const params = {...filters, page: page};
        return this.get(`satisfaction-polls`, params);
    },
    loadSatisfactionPollModes(){
        return this.get(`satisfaction-polls/modes`);
    },
    loadSatisfactionPollQuestions(){
        return this.get(`satisfaction-polls/questions`);
    },
    saveSatisfactionPoll(satisfactionPoll) {
        return this.post(`satisfaction-polls`, satisfactionPoll);
    },
    updateSatisfactionPoll(satisfactionPoll, id) {
        return this.put('satisfaction-polls/' + id, satisfactionPoll);
    },
    deleteSatisfactionPoll(id){
        return this.delete('satisfaction-polls/'+ id);
    }
}